module.exports = __webpack_public_path__ + "russierenouvelables/img/wave-map.cbd7924f.webp";